import IntrovokeEmbed from './IntrovokeEmbed';

export default IntrovokeEmbed;
